import React from 'react';
import {Route, Switch} from 'react-router';
import UpdatePasswordForm from './UpdatePasswordForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import ConfirmEmailForm from './ConfirmEmailForm';
import LoginForm from './LoginForm';
import useCurrentUser from 'mrf/utils/useCurrentUser';
import {useRouteMatch} from 'react-router-dom';
import path from 'path';
import Paper from "../Paper";
import PageTitle from "../Title";
import {Col, Grid} from "../Grid";
import T from "../../utils/T";
import {EnableTOTPForm} from "../dialogForms/EnableTOTPForm";

export default function Authenticate({children}) {
    const match = useRouteMatch();
    const user = useCurrentUser();
    const userRoles = user?.roles?.map((userRole => userRole?.role?.code?.toUpperCase()));

    if (!user) {
        return false;
    }

    if (userRoles?.includes("NEEDS_2FA")) {
        return <Paper className='max-w-screen-lg mx-auto mt-5'>
            <PageTitle>Enable Two Factor Authentication</PageTitle>
            <Grid>
                <Col size={6}>
                    <p>
                        <T>For security reasons, the system administrator requires all users to enable Two Factor
                            Authentication.</T> <br/>
                        <T>To proceed, please follow the procedure below:</T>
                    </p>
                </Col>
            </Grid>
            <EnableTOTPForm/>
        </Paper>
    }

    if (!user?.id) {
        return <div className='flex items-center justify-center h-full'>
            <div className='flex flex-col w-1/3'>
                <Switch>
                    <Route exact path={match.url} component={LoginForm}/>
                    <Route path={path.join(match.url, '/updatePassword')} component={UpdatePasswordForm}/>
                    <Route path={path.join(match.url, '/forgotPassword')} component={ForgotPasswordForm}/>
                    <Route path={path.join(match.url, '/confirmEmail')} component={ConfirmEmailForm}/>
                    <Route path={match.url} component={LoginForm}/>
                </Switch>
            </div>
        </div>
    }

    return children;
}
